import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/sans-serif.js
t.dynamicSetup("", "sans-serif", e({
	SS: {
		normal: {
			8513: [
				.706,
				.011,
				.667
			],
			8514: [
				.694,
				0,
				.542
			],
			8515: [
				.694,
				0,
				.542
			],
			8516: [
				.694,
				0,
				.667
			],
			120224: [
				.694,
				0,
				.667
			],
			120225: [
				.694,
				0,
				.667,
				{ sk: -.077 }
			],
			120226: [
				.706,
				.011,
				.639,
				{ sk: .091 }
			],
			120227: [
				.694,
				0,
				.722,
				{ sk: -.109 }
			],
			120228: [
				.691,
				0,
				.597,
				{ sk: .018 }
			],
			120229: [
				.691,
				0,
				.569,
				{ sk: .025 }
			],
			120230: [
				.706,
				.011,
				.667,
				{ sk: .073 }
			],
			120231: [
				.694,
				0,
				.708
			],
			120232: [
				.694,
				0,
				.278
			],
			120233: [
				.694,
				.022,
				.472,
				{ sk: .109 }
			],
			120234: [
				.694,
				0,
				.694,
				{ sk: .02 }
			],
			120235: [
				.694,
				0,
				.542,
				{ sk: -.132 }
			],
			120236: [
				.694,
				0,
				.875
			],
			120237: [
				.694,
				0,
				.708
			],
			120238: [
				.716,
				.022,
				.736
			],
			120239: [
				.694,
				0,
				.639,
				{ sk: -.06 }
			],
			120240: [
				.716,
				.125,
				.736
			],
			120241: [
				.694,
				0,
				.646,
				{ sk: -.066 }
			],
			120242: [
				.716,
				.022,
				.556,
				{ sk: .015 }
			],
			120243: [
				.688,
				0,
				.681
			],
			120244: [
				.694,
				.022,
				.688
			],
			120245: [
				.694,
				0,
				.667
			],
			120246: [
				.694,
				0,
				.944
			],
			120247: [
				.694,
				0,
				.667,
				{ sk: -.015 }
			],
			120248: [
				.694,
				0,
				.667
			],
			120249: [
				.694,
				0,
				.611
			],
			120250: [
				.461,
				.011,
				.481,
				{ sk: -.013 }
			],
			120251: [
				.694,
				.011,
				.517,
				{ sk: -.139 }
			],
			120252: [
				.461,
				.011,
				.444,
				{ sk: .042 }
			],
			120253: [
				.694,
				.011,
				.517,
				{ sk: .139 }
			],
			120254: [
				.461,
				.011,
				.444,
				{ sk: .016 }
			],
			120255: [
				.705,
				0,
				.306,
				{
					ic: .041,
					sk: .096
				}
			],
			120256: [
				.455,
				.206,
				.5,
				{ sk: .074 }
			],
			120257: [
				.694,
				0,
				.517,
				{ sk: -.14 }
			],
			120258: [
				.655,
				0,
				.239
			],
			120259: [
				.655,
				.205,
				.267
			],
			120260: [
				.694,
				0,
				.489,
				{ sk: -.124 }
			],
			120261: [
				.694,
				0,
				.239
			],
			120262: [
				.455,
				0,
				.794,
				{ sk: -.038 }
			],
			120263: [
				.455,
				0,
				.517,
				{ sk: -.038 }
			],
			120264: [
				.461,
				.011,
				.5
			],
			120265: [
				.455,
				.194,
				.517,
				{ sk: -.03 }
			],
			120266: [
				.455,
				.194,
				.517,
				{ sk: .041 }
			],
			120267: [
				.455,
				0,
				.342,
				{ sk: .034 }
			],
			120268: [
				.461,
				.011,
				.383,
				{ sk: .022 }
			],
			120269: [
				.571,
				.011,
				.361,
				{ sk: -.04 }
			],
			120270: [
				.444,
				.011,
				.517
			],
			120271: [
				.444,
				0,
				.461
			],
			120272: [
				.444,
				0,
				.683
			],
			120273: [
				.444,
				0,
				.461,
				{ ic: .004 }
			],
			120274: [
				.444,
				.205,
				.461
			],
			120275: [
				.444,
				0,
				.435
			],
			120802: [
				.678,
				.022,
				.5
			],
			120803: [
				.678,
				0,
				.5,
				{ sk: .01 }
			],
			120804: [
				.678,
				0,
				.5
			],
			120805: [
				.678,
				.022,
				.5
			],
			120806: [
				.656,
				0,
				.5,
				{ sk: .073 }
			],
			120807: [
				.656,
				.022,
				.5
			],
			120808: [
				.678,
				.022,
				.5,
				{ sk: .084 }
			],
			120809: [
				.656,
				.011,
				.5
			],
			120810: [
				.678,
				.022,
				.5
			],
			120811: [
				.678,
				.022,
				.5
			]
		},
		"sans-serif": {
			305: [
				.444,
				0,
				.239,
				{ sk: .277 }
			],
			567: [
				.444,
				.205,
				.267,
				{ sk: .157 }
			],
			32: [
				0,
				0,
				.333
			],
			33: [
				.694,
				0,
				.319
			],
			34: [
				.716,
				-.43,
				.434
			],
			35: [
				.694,
				.194,
				.833
			],
			36: [
				.75,
				.056,
				.5
			],
			37: [
				.75,
				.056,
				.833
			],
			38: [
				.716,
				.022,
				.758
			],
			39: [
				.716,
				-.43,
				.278
			],
			40: [
				.75,
				.25,
				.389
			],
			41: [
				.75,
				.25,
				.389
			],
			42: [
				.75,
				-.306,
				.5
			],
			43: [
				.583,
				.083,
				.778
			],
			44: [
				.083,
				.125,
				.278
			],
			45: [
				.251,
				-.193,
				.333
			],
			46: [
				.083,
				0,
				.278
			],
			47: [
				.75,
				.25,
				.5
			],
			58: [
				.444,
				0,
				.278
			],
			59: [
				.444,
				.125,
				.278
			],
			60: [
				.54,
				.04,
				.778
			],
			61: [
				.37,
				-.13,
				.778
			],
			62: [
				.54,
				.04,
				.778
			],
			63: [
				.705,
				0,
				.472
			],
			64: [
				.705,
				.011,
				.667
			],
			91: [
				.75,
				.25,
				.289
			],
			92: [
				.75,
				.25,
				.5
			],
			93: [
				.75,
				.25,
				.289
			],
			94: [
				.745,
				-.561,
				.556,
				{ ic: .006 }
			],
			95: [
				-.086,
				.164,
				.667
			],
			96: [
				.694,
				-.527,
				.5
			],
			123: [
				.75,
				.25,
				.5
			],
			124: [
				.75,
				.25,
				.278
			],
			125: [
				.75,
				.25,
				.5
			],
			126: [
				.309,
				-.191,
				.556,
				{ ic: .001 }
			],
			160: [
				0,
				0,
				.333
			],
			163: [
				.694,
				.022,
				.667
			],
			165: [
				.694,
				0,
				.667
			],
			167: [
				.712,
				.212,
				.528
			],
			168: [
				.651,
				-.571,
				.5
			],
			172: [
				.37,
				-.13,
				.778
			],
			175: [
				.631,
				-.567,
				.5
			],
			176: [
				.694,
				-.417,
				.375
			],
			177: [
				.666,
				0,
				.778
			],
			180: [
				.694,
				-.527,
				.5
			],
			181: [
				.444,
				.194,
				.517
			],
			182: [
				.694,
				.194,
				.611
			],
			183: [
				.389,
				-.306,
				.778
			],
			215: [
				.491,
				-.01,
				.778
			],
			240: [
				.725,
				.011,
				.5
			],
			247: [
				.414,
				-.085,
				.778
			],
			710: [
				.697,
				-.525,
				.5
			],
			711: [
				.697,
				-.525,
				.5
			],
			713: [
				.631,
				-.567,
				.5
			],
			714: [
				.694,
				-.527,
				.5
			],
			715: [
				.694,
				-.527,
				.5
			],
			728: [
				.7,
				-.522,
				.5
			],
			729: [
				.655,
				-.566,
				.278
			],
			730: [
				.7,
				-.504,
				.296
			],
			732: [
				.67,
				-.551,
				.5
			],
			768: [
				.694,
				-.527,
				0,
				{ dx: .276 }
			],
			769: [
				.694,
				-.527,
				0,
				{ dx: .204 }
			],
			770: [
				.697,
				-.525,
				0,
				{ dx: .24 }
			],
			771: [
				.67,
				-.551,
				0,
				{ dx: .239 }
			],
			772: [
				.643,
				-.579,
				0,
				{ dx: .239 }
			],
			773: [
				.682,
				-.642,
				.778
			],
			774: [
				.7,
				-.522,
				0,
				{ dx: .239 }
			],
			775: [
				.655,
				-.566,
				0,
				{ dx: .24 }
			],
			776: [
				.651,
				-.571,
				0,
				{ dx: .24 }
			],
			778: [
				.7,
				-.504,
				.296
			],
			780: [
				.697,
				-.525,
				0,
				{ dx: .24 }
			],
			913: [
				.694,
				0,
				.667
			],
			914: [
				.694,
				0,
				.667
			],
			915: [
				.691,
				0,
				.542
			],
			916: [
				.694,
				0,
				.833
			],
			917: [
				.691,
				0,
				.597
			],
			918: [
				.694,
				0,
				.611
			],
			919: [
				.694,
				0,
				.708
			],
			920: [
				.716,
				.022,
				.778
			],
			921: [
				.695,
				0,
				.278
			],
			922: [
				.694,
				0,
				.694
			],
			923: [
				.694,
				0,
				.611
			],
			924: [
				.694,
				0,
				.875
			],
			925: [
				.694,
				0,
				.708
			],
			926: [
				.689,
				0,
				.667
			],
			927: [
				.716,
				.022,
				.736
			],
			928: [
				.691,
				0,
				.708
			],
			929: [
				.694,
				0,
				.639
			],
			931: [
				.694,
				0,
				.722
			],
			932: [
				.689,
				0,
				.68
			],
			933: [
				.716,
				0,
				.778
			],
			934: [
				.694,
				0,
				.722
			],
			935: [
				.694,
				0,
				.667
			],
			936: [
				.694,
				0,
				.778
			],
			937: [
				.716,
				0,
				.722
			],
			945: [
				.455,
				.011,
				.633
			],
			946: [
				.733,
				.139,
				.5
			],
			947: [
				.455,
				.171,
				.555
			],
			948: [
				.721,
				.011,
				.472
			],
			949: [
				.455,
				.011,
				.43
			],
			950: [
				.738,
				.153,
				.472
			],
			951: [
				.467,
				.195,
				.514
			],
			952: [
				.733,
				.011,
				.5
			],
			953: [
				.445,
				.011,
				.278
			],
			954: [
				.445,
				0,
				.483
			],
			955: [
				.722,
				0,
				.5
			],
			956: [
				.445,
				.195,
				.555
			],
			957: [
				.445,
				0,
				.472
			],
			958: [
				.744,
				.156,
				.472
			],
			959: [
				.455,
				.011,
				.528
			],
			960: [
				.445,
				.011,
				.583
			],
			961: [
				.455,
				.195,
				.472
			],
			962: [
				.445,
				.13,
				.444
			],
			963: [
				.445,
				.011,
				.569
			],
			964: [
				.445,
				.011,
				.458
			],
			965: [
				.445,
				.011,
				.5
			],
			966: [
				.455,
				.195,
				.583
			],
			967: [
				.458,
				.208,
				.555
			],
			968: [
				.722,
				.195,
				.583
			],
			969: [
				.445,
				.011,
				.667
			],
			977: [
				.733,
				.011,
				.5
			],
			978: [
				.716,
				0,
				.778
			],
			981: [
				.714,
				.195,
				.583
			],
			982: [
				.445,
				.011,
				.807
			],
			1008: [
				.458,
				.022,
				.555
			],
			1009: [
				.455,
				.249,
				.472
			],
			1012: [
				.716,
				.022,
				.778
			],
			1013: [
				.455,
				.011,
				.43
			],
			1014: [
				.455,
				.011,
				.43
			],
			8208: [
				.251,
				-.193,
				.333
			],
			8209: [
				.251,
				-.193,
				.333
			],
			8210: [
				.305,
				-.244,
				.5
			],
			8211: [
				.305,
				-.244,
				.5
			],
			8212: [
				.305,
				-.244,
				1
			],
			8214: [
				.75,
				.25,
				.398
			],
			8216: [
				.694,
				-.486,
				.278
			],
			8217: [
				.694,
				-.486,
				.278
			],
			8220: [
				.694,
				-.486,
				.472
			],
			8221: [
				.694,
				-.486,
				.472
			],
			8224: [
				.705,
				.216,
				.444
			],
			8225: [
				.705,
				.205,
				.444
			],
			8230: [
				.083,
				0,
				.626
			],
			8260: [
				.674,
				-.02,
				.558
			],
			8364: [
				.716,
				.022,
				.599
			],
			8486: [
				.716,
				0,
				.722
			],
			8487: [
				.694,
				.022,
				.722
			],
			8592: [
				.511,
				.009,
				1
			],
			8593: [
				.711,
				.195,
				.5
			],
			8594: [
				.511,
				.009,
				1
			],
			8595: [
				.694,
				.211,
				.5
			],
			8722: [
				.27,
				-.23,
				.778
			],
			8734: [
				.468,
				.024,
				1
			]
		}
	},
	SSB: {
		normal: {
			120276: [
				.694,
				0,
				.733
			],
			120277: [
				.694,
				0,
				.733,
				{ sk: -.07 }
			],
			120278: [
				.706,
				.011,
				.703,
				{ sk: .082 }
			],
			120279: [
				.694,
				0,
				.794,
				{ sk: -.096 }
			],
			120280: [
				.692,
				0,
				.642,
				{ sk: .015 }
			],
			120281: [
				.692,
				0,
				.611,
				{ sk: .022 }
			],
			120282: [
				.706,
				.011,
				.733,
				{ sk: .061 }
			],
			120283: [
				.694,
				0,
				.794
			],
			120284: [
				.694,
				0,
				.331
			],
			120285: [
				.694,
				.022,
				.519,
				{ sk: .097 }
			],
			120286: [
				.694,
				0,
				.764,
				{ sk: .016 }
			],
			120287: [
				.694,
				0,
				.581,
				{ sk: -.126 }
			],
			120288: [
				.694,
				0,
				.978
			],
			120289: [
				.694,
				0,
				.794
			],
			120290: [
				.717,
				.022,
				.794
			],
			120291: [
				.694,
				0,
				.703,
				{ sk: -.064 }
			],
			120292: [
				.717,
				.111,
				.794
			],
			120293: [
				.694,
				0,
				.703,
				{ sk: -.056 }
			],
			120294: [
				.717,
				.022,
				.611
			],
			120295: [
				.689,
				0,
				.733
			],
			120296: [
				.694,
				.022,
				.764
			],
			120297: [
				.694,
				0,
				.733
			],
			120298: [
				.694,
				0,
				1.039
			],
			120299: [
				.694,
				0,
				.733,
				{ sk: -.015 }
			],
			120300: [
				.694,
				0,
				.733
			],
			120301: [
				.694,
				0,
				.672
			],
			120302: [
				.489,
				.011,
				.525
			],
			120303: [
				.694,
				.011,
				.561,
				{ sk: -.152 }
			],
			120304: [
				.489,
				.011,
				.489,
				{ sk: .041 }
			],
			120305: [
				.694,
				.011,
				.561,
				{ sk: .152 }
			],
			120306: [
				.489,
				.011,
				.511,
				{ sk: .011 }
			],
			120307: [
				.706,
				0,
				.336,
				{
					ic: .044,
					sk: .088
				}
			],
			120308: [
				.483,
				.191,
				.561,
				{ sk: .059 }
			],
			120309: [
				.694,
				0,
				.561,
				{ sk: -.153 }
			],
			120310: [
				.694,
				0,
				.256
			],
			120311: [
				.694,
				.178,
				.286
			],
			120312: [
				.694,
				0,
				.531,
				{ sk: -.138 }
			],
			120313: [
				.694,
				0,
				.256
			],
			120314: [
				.483,
				0,
				.867,
				{ sk: -.028 }
			],
			120315: [
				.483,
				0,
				.561,
				{ sk: -.028 }
			],
			120316: [
				.489,
				.011,
				.55
			],
			120317: [
				.483,
				.167,
				.561,
				{ sk: -.043 }
			],
			120318: [
				.483,
				.167,
				.561,
				{ sk: .061 }
			],
			120319: [
				.483,
				0,
				.372,
				{ sk: .03 }
			],
			120320: [
				.489,
				.011,
				.422,
				{ sk: .015 }
			],
			120321: [
				.607,
				.011,
				.404,
				{ sk: -.047 }
			],
			120322: [
				.472,
				.011,
				.561
			],
			120323: [
				.472,
				0,
				.5
			],
			120324: [
				.472,
				0,
				.744
			],
			120325: [
				.472,
				0,
				.5
			],
			120326: [
				.472,
				.178,
				.5
			],
			120327: [
				.472,
				0,
				.476
			],
			120812: [
				.717,
				.022,
				.55
			],
			120813: [
				.717,
				0,
				.55
			],
			120814: [
				.717,
				0,
				.55,
				{ sk: -.016 }
			],
			120815: [
				.717,
				.022,
				.55
			],
			120816: [
				.694,
				0,
				.55,
				{ sk: .068 }
			],
			120817: [
				.694,
				.022,
				.55
			],
			120818: [
				.717,
				.022,
				.55,
				{ sk: .056 }
			],
			120819: [
				.694,
				.011,
				.55
			],
			120820: [
				.717,
				.022,
				.55
			],
			120821: [
				.717,
				.022,
				.55,
				{ sk: -.016 }
			],
			120662: [
				.694,
				0,
				.733
			],
			120663: [
				.694,
				0,
				.733,
				{ sk: -.04 }
			],
			120664: [
				.694,
				0,
				.58,
				{ sk: .023 }
			],
			120665: [
				.694,
				0,
				.916
			],
			120666: [
				.692,
				0,
				.642,
				{ sk: .015 }
			],
			120667: [
				.694,
				0,
				.672
			],
			120668: [
				.694,
				0,
				.794
			],
			120669: [
				.716,
				.022,
				.855
			],
			120670: [
				.694,
				0,
				.331
			],
			120671: [
				.694,
				0,
				.764,
				{ sk: .012 }
			],
			120672: [
				.694,
				0,
				.672
			],
			120673: [
				.694,
				0,
				.978
			],
			120674: [
				.694,
				0,
				.794
			],
			120675: [
				.689,
				0,
				.733
			],
			120676: [
				.717,
				.022,
				.794
			],
			120677: [
				.691,
				0,
				.794
			],
			120678: [
				.694,
				0,
				.703,
				{ sk: -.034 }
			],
			120679: [
				.716,
				.022,
				.856
			],
			120680: [
				.693,
				0,
				.794
			],
			120681: [
				.689,
				0,
				.733
			],
			120682: [
				.716,
				0,
				.855
			],
			120683: [
				.694,
				0,
				.794
			],
			120684: [
				.694,
				0,
				.733,
				{ sk: -.015 }
			],
			120685: [
				.694,
				0,
				.855
			],
			120686: [
				.716,
				0,
				.794
			],
			120687: [
				.694,
				0,
				.916
			],
			120688: [
				.455,
				.011,
				.633
			],
			120689: [
				.733,
				.139,
				.5,
				{ sk: -.024 }
			],
			120690: [
				.455,
				.171,
				.555
			],
			120691: [
				.721,
				.011,
				.472,
				{ sk: .017 }
			],
			120692: [
				.455,
				.011,
				.43
			],
			120693: [
				.744,
				.153,
				.472
			],
			120694: [
				.467,
				.195,
				.514,
				{ sk: .018 }
			],
			120695: [
				.733,
				.011,
				.5
			],
			120696: [
				.445,
				.011,
				.278,
				{ sk: -.046 }
			],
			120697: [
				.445,
				0,
				.483
			],
			120698: [
				.722,
				0,
				.5,
				{ sk: -.133 }
			],
			120699: [
				.445,
				.195,
				.555,
				{ sk: -.038 }
			],
			120700: [
				.445,
				0,
				.472,
				{ sk: .013 }
			],
			120701: [
				.747,
				.156,
				.472
			],
			120702: [
				.455,
				.011,
				.528
			],
			120703: [
				.445,
				.011,
				.583
			],
			120704: [
				.455,
				.195,
				.472
			],
			120705: [
				.445,
				.13,
				.444
			],
			120706: [
				.445,
				.011,
				.569,
				{ sk: -.018 }
			],
			120707: [
				.445,
				.011,
				.458,
				{ sk: -.025 }
			],
			120708: [
				.445,
				.011,
				.5
			],
			120709: [
				.455,
				.195,
				.583
			],
			120710: [
				.458,
				.208,
				.555
			],
			120711: [
				.722,
				.195,
				.583
			],
			120712: [
				.445,
				.011,
				.667
			],
			120713: [
				.716,
				.022,
				.569
			],
			120714: [
				.455,
				.011,
				.43,
				{ sk: .016 }
			],
			120715: [
				.705,
				.012,
				.811,
				{ sk: .07 }
			],
			120716: [
				.492,
				.033,
				.609
			],
			120717: [
				.695,
				.195,
				.611
			],
			120718: [
				.469,
				.245,
				.567
			],
			120719: [
				.458,
				.012,
				1.035,
				{ sk: .049 }
			]
		},
		"bold-sans-serif": {
			305: [
				.458,
				0,
				.256,
				{ sk: .212 }
			],
			567: [
				.458,
				.205,
				.286,
				{ sk: .194 }
			],
			32: [
				0,
				0,
				.367
			],
			33: [
				.694,
				0,
				.367
			],
			35: [
				.694,
				.167,
				.917
			],
			36: [
				.75,
				.056,
				.55
			],
			37: [
				.773,
				.079,
				1.029
			],
			38: [
				.717,
				.022,
				.831
			],
			39: [
				.695,
				-.453,
				.306
			],
			40: [
				.75,
				.222,
				.428
			],
			41: [
				.75,
				.222,
				.428
			],
			42: [
				.75,
				-.278,
				.55
			],
			43: [
				.626,
				.098,
				.856
			],
			44: [
				.131,
				.111,
				.306
			],
			45: [
				.272,
				-.2,
				.367
			],
			46: [
				.131,
				0,
				.306
			],
			47: [
				.775,
				.195,
				.55
			],
			58: [
				.471,
				0,
				.306
			],
			59: [
				.471,
				.111,
				.306
			],
			61: [
				.425,
				-.103,
				.856
			],
			63: [
				.706,
				0,
				.519
			],
			64: [
				.706,
				.011,
				.733
			],
			91: [
				.75,
				.222,
				.343
			],
			92: [
				.775,
				.262,
				.575
			],
			93: [
				.75,
				.222,
				.343
			],
			94: [
				.744,
				-.562,
				.556,
				{ ic: .005 }
			],
			95: [
				-.057,
				.193,
				.733
			],
			96: [
				.694,
				-.537,
				.55
			],
			123: [
				.75,
				.25,
				.575
			],
			124: [
				.796,
				.282,
				.338
			],
			125: [
				.75,
				.25,
				.575
			],
			126: [
				.327,
				-.173,
				.556
			],
			160: [
				0,
				0,
				.367
			],
			163: [
				.694,
				.047,
				.733
			],
			165: [
				.694,
				0,
				.733
			],
			167: [
				.709,
				.209,
				.566
			],
			168: [
				.62,
				-.515,
				.527
			],
			172: [
				.408,
				-.098,
				.856
			],
			175: [
				.658,
				-.573,
				.55
			],
			176: [
				.694,
				-.389,
				.413
			],
			177: [
				.691,
				0,
				.856
			],
			180: [
				.694,
				-.537,
				.55
			],
			181: [
				.445,
				.195,
				.555
			],
			182: [
				.694,
				.194,
				.703
			],
			183: [
				.413,
				-.282,
				.856
			],
			215: [
				.54,
				.039,
				.856
			],
			240: [
				.69,
				.01,
				.55
			],
			247: [
				.507,
				.039,
				.856
			],
			710: [
				.694,
				-.546,
				.55
			],
			711: [
				.661,
				-.513,
				.55
			],
			713: [
				.658,
				-.573,
				.55
			],
			714: [
				.694,
				-.537,
				.55
			],
			715: [
				.694,
				-.537,
				.55
			],
			728: [
				.694,
				-.522,
				.55
			],
			729: [
				.699,
				-.594,
				.306
			],
			730: [
				.729,
				-.546,
				.223
			],
			732: [
				.694,
				-.567,
				.55
			],
			768: [
				.684,
				-.537,
				0,
				{ dx: .203 }
			],
			769: [
				.685,
				-.537,
				0,
				{ dx: .199 }
			],
			770: [
				.698,
				-.549,
				0,
				{ dx: .261 }
			],
			771: [
				.668,
				-.553,
				.733
			],
			772: [
				.658,
				-.573,
				0,
				{ dx: .262 }
			],
			773: [
				.717,
				-.632,
				.855
			],
			774: [
				.708,
				-.536,
				.256
			],
			775: [
				.672,
				-.567,
				0,
				{ dx: .252 }
			],
			776: [
				.672,
				-.567,
				.733
			],
			778: [
				.705,
				-.522,
				.733
			],
			780: [
				.698,
				-.549,
				0,
				{ dx: .251 }
			],
			978: [
				.716,
				0,
				.778
			],
			1014: [
				.455,
				.011,
				.43
			],
			8208: [
				.265,
				-.193,
				.367
			],
			8209: [
				.265,
				-.193,
				.367
			],
			8210: [
				.32,
				-.247,
				.55
			],
			8211: [
				.328,
				-.256,
				.55
			],
			8212: [
				.328,
				-.256,
				1.1
			],
			8214: [
				.75,
				.25,
				.571
			],
			8216: [
				.722,
				-.48,
				.306
			],
			8217: [
				.722,
				-.48,
				.305
			],
			8220: [
				.722,
				-.48,
				.61
			],
			8221: [
				.722,
				-.48,
				.61
			],
			8224: [
				.702,
				.211,
				.511
			],
			8225: [
				.702,
				.202,
				.511
			],
			8230: [
				.131,
				0,
				.768
			],
			8260: [
				.735,
				.039,
				.55,
				{ ic: .055 }
			],
			8364: [
				.716,
				.022,
				.658
			],
			8486: [
				.716,
				0,
				.794
			],
			8487: [
				.716,
				0,
				.794
			],
			8592: [
				.548,
				.046,
				1.1
			],
			8593: [
				.668,
				.194,
				.622
			],
			8594: [
				.548,
				.046,
				1.1
			],
			8595: [
				.668,
				.194,
				.622
			],
			8722: [
				.293,
				-.208,
				.856
			],
			8734: [
				.492,
				.034,
				1.1
			]
		}
	},
	SSI: {
		normal: {
			120328: [
				.694,
				0,
				.667,
				{ sk: .147 }
			],
			120329: [
				.694,
				0,
				.667,
				{
					ic: .03,
					sk: .047
				}
			],
			120330: [
				.706,
				.011,
				.639,
				{
					ic: .08,
					sk: .179
				}
			],
			120331: [
				.694,
				0,
				.722,
				{
					ic: .025,
					sk: .02
				}
			],
			120332: [
				.691,
				0,
				.597,
				{
					ic: .091,
					sk: .097
				}
			],
			120333: [
				.691,
				0,
				.569,
				{
					ic: .105,
					sk: .094
				}
			],
			120334: [
				.706,
				.011,
				.667,
				{
					ic: .063,
					sk: .173
				}
			],
			120335: [
				.694,
				0,
				.708,
				{
					ic: .054,
					sk: .107
				}
			],
			120336: [
				.694,
				0,
				.278,
				{
					ic: .054,
					sk: .107
				}
			],
			120337: [
				.694,
				.022,
				.472,
				{
					ic: .065,
					sk: .208
				}
			],
			120338: [
				.694,
				0,
				.694,
				{
					ic: .098,
					sk: .095
				}
			],
			120339: [
				.694,
				0,
				.542,
				{ sk: .016 }
			],
			120340: [
				.694,
				0,
				.875,
				{
					ic: .048,
					sk: .112
				}
			],
			120341: [
				.694,
				0,
				.708,
				{
					ic: .052,
					sk: .109
				}
			],
			120342: [
				.716,
				.022,
				.736,
				{
					ic: .026,
					sk: .132
				}
			],
			120343: [
				.694,
				0,
				.639,
				{
					ic: .052,
					sk: .048
				}
			],
			120344: [
				.716,
				.125,
				.736,
				{
					ic: .027,
					sk: .131
				}
			],
			120345: [
				.694,
				0,
				.646,
				{
					ic: .054,
					sk: .041
				}
			],
			120346: [
				.716,
				.022,
				.556,
				{
					ic: .052,
					sk: .125
				}
			],
			120347: [
				.688,
				0,
				.681,
				{
					ic: .11,
					sk: .061
				}
			],
			120348: [
				.694,
				.022,
				.688,
				{
					ic: .054,
					sk: .105
				}
			],
			120349: [
				.694,
				0,
				.667,
				{
					ic: .136,
					sk: .045
				}
			],
			120350: [
				.694,
				0,
				.944,
				{
					ic: .135,
					sk: .047
				}
			],
			120351: [
				.694,
				0,
				.667,
				{
					ic: .096,
					sk: .061
				}
			],
			120352: [
				.694,
				0,
				.667,
				{
					ic: .149,
					sk: .036
				}
			],
			120353: [
				.694,
				0,
				.611,
				{
					ic: .092,
					sk: .084
				}
			],
			120354: [
				.461,
				.011,
				.481,
				{ sk: .084 }
			],
			120355: [
				.694,
				.011,
				.517,
				{ ic: .018 }
			],
			120356: [
				.461,
				.011,
				.444,
				{
					ic: .056,
					sk: .095
				}
			],
			120357: [
				.694,
				.011,
				.517,
				{
					ic: .066,
					sk: .236
				}
			],
			120358: [
				.461,
				.011,
				.444,
				{
					ic: .027,
					sk: .091
				}
			],
			120359: [
				.705,
				0,
				.306,
				{
					ic: .19,
					sk: .133
				}
			],
			120360: [
				.455,
				.206,
				.5,
				{
					ic: .071,
					sk: .116
				}
			],
			120361: [
				.694,
				0,
				.517
			],
			120362: [
				.655,
				0,
				.239,
				{
					ic: .065,
					sk: .09
				}
			],
			120363: [
				.655,
				.205,
				.267,
				{
					ic: .057,
					sk: .102
				}
			],
			120364: [
				.694,
				0,
				.489,
				{
					ic: .061,
					sk: -.022
				}
			],
			120365: [
				.694,
				0,
				.239,
				{
					ic: .066,
					sk: .098
				}
			],
			120366: [
				.455,
				0,
				.794,
				{ sk: .057 }
			],
			120367: [
				.455,
				0,
				.517,
				{ sk: .057 }
			],
			120368: [
				.461,
				.011,
				.5,
				{
					ic: .022,
					sk: .079
				}
			],
			120369: [
				.455,
				.194,
				.517,
				{
					ic: .018,
					sk: .05
				}
			],
			120370: [
				.455,
				.194,
				.517,
				{
					ic: .015,
					sk: .125
				}
			],
			120371: [
				.455,
				0,
				.342,
				{
					ic: .083,
					sk: .068
				}
			],
			120372: [
				.461,
				.011,
				.383,
				{
					ic: .052,
					sk: .08
				}
			],
			120373: [
				.571,
				.011,
				.361,
				{
					ic: .05,
					sk: .042
				}
			],
			120374: [
				.444,
				.011,
				.517,
				{
					ic: .013,
					sk: .083
				}
			],
			120375: [
				.444,
				0,
				.461,
				{
					ic: .082,
					sk: .032
				}
			],
			120376: [
				.444,
				0,
				.683,
				{
					ic: .082,
					sk: .032
				}
			],
			120377: [
				.444,
				0,
				.461,
				{
					ic: .082,
					sk: .027
				}
			],
			120378: [
				.444,
				.205,
				.461,
				{
					ic: .082,
					sk: .032
				}
			],
			120379: [
				.444,
				0,
				.435,
				{
					ic: .06,
					sk: .051
				}
			]
		},
		"sans-serif-italic": {
			305: [
				.444,
				0,
				.239,
				{
					ic: .012,
					sk: .205
				}
			],
			567: [
				.444,
				.205,
				.267,
				{
					ic: .012,
					sk: .117
				}
			],
			32: [
				0,
				0,
				.333
			],
			33: [
				.694,
				0,
				.319,
				{ ic: .031 }
			],
			34: [
				.716,
				-.43,
				.434,
				{ ic: .053 }
			],
			35: [
				.694,
				.194,
				.833,
				{ ic: .021 }
			],
			36: [
				.75,
				.056,
				.5,
				{ ic: .066 }
			],
			37: [
				.75,
				.056,
				.833
			],
			38: [
				.716,
				.022,
				.758
			],
			39: [
				.716,
				-.43,
				.278,
				{ ic: .053 }
			],
			40: [
				.75,
				.25,
				.389,
				{ ic: .109 }
			],
			41: [
				.75,
				.25,
				.389
			],
			42: [
				.75,
				-.306,
				.5,
				{ ic: .071 }
			],
			43: [
				.583,
				.083,
				.778
			],
			44: [
				.083,
				.125,
				.278
			],
			45: [
				.251,
				-.193,
				.333
			],
			46: [
				.083,
				0,
				.278
			],
			47: [
				.75,
				.25,
				.5,
				{ ic: .101 }
			],
			48: [
				.678,
				.022,
				.5,
				{ ic: .046 }
			],
			49: [
				.678,
				0,
				.5
			],
			50: [
				.678,
				0,
				.5,
				{ ic: .053 }
			],
			51: [
				.678,
				.022,
				.5,
				{ ic: .045 }
			],
			52: [
				.656,
				0,
				.5,
				{ ic: .021 }
			],
			53: [
				.656,
				.022,
				.5,
				{ ic: .056 }
			],
			54: [
				.678,
				.022,
				.5,
				{ ic: .056 }
			],
			55: [
				.656,
				.011,
				.5,
				{ ic: .097 }
			],
			56: [
				.678,
				.022,
				.5,
				{ ic: .054 }
			],
			57: [
				.678,
				.022,
				.5,
				{ ic: .045 }
			],
			58: [
				.444,
				0,
				.278
			],
			59: [
				.444,
				.125,
				.278
			],
			60: [
				.54,
				.04,
				.778,
				{ ic: .03 }
			],
			61: [
				.37,
				-.13,
				.778,
				{ ic: .021 }
			],
			62: [
				.54,
				.04,
				.778
			],
			63: [
				.705,
				0,
				.472,
				{ ic: .064 }
			],
			64: [
				.705,
				.011,
				.667,
				{ ic: .038 }
			],
			91: [
				.75,
				.25,
				.289,
				{ ic: .137 }
			],
			92: [
				.75,
				.25,
				.5
			],
			93: [
				.75,
				.25,
				.289,
				{ ic: .057 }
			],
			94: [
				.745,
				-.561,
				.556,
				{ ic: .131 }
			],
			95: [
				-.086,
				.164,
				.667
			],
			96: [
				.694,
				-.527,
				.5
			],
			123: [
				.75,
				.25,
				.5,
				{ ic: .086 }
			],
			124: [
				.75,
				.25,
				.278,
				{ ic: .038 }
			],
			125: [
				.75,
				.25,
				.5
			],
			126: [
				.309,
				-.191,
				.556,
				{ ic: .062 }
			],
			160: [
				0,
				0,
				.333
			],
			163: [
				.694,
				.022,
				.667
			],
			165: [
				.694,
				0,
				.667,
				{ ic: .149 }
			],
			167: [
				.712,
				.212,
				.528,
				{ ic: .043 }
			],
			168: [
				.651,
				-.571,
				.5,
				{ ic: .002 }
			],
			172: [
				.37,
				-.13,
				.778,
				{ ic: .02 }
			],
			175: [
				.631,
				-.567,
				.5,
				{ ic: .065 }
			],
			176: [
				.694,
				-.417,
				.375,
				{ ic: .072 }
			],
			177: [
				.666,
				0,
				.778,
				{ ic: .018 }
			],
			180: [
				.694,
				-.527,
				.5,
				{ ic: .045 }
			],
			181: [
				.444,
				.194,
				.517,
				{ ic: .013 }
			],
			182: [
				.694,
				.194,
				.611,
				{ ic: .118 }
			],
			183: [
				.389,
				-.306,
				.778
			],
			215: [
				.492,
				-.01,
				.778
			],
			240: [
				.725,
				.011,
				.5,
				{ ic: .034 }
			],
			247: [
				.414,
				-.085,
				.778
			],
			710: [
				.697,
				-.525,
				.5,
				{ ic: .02 }
			],
			711: [
				.697,
				-.525,
				.5,
				{ ic: .058 }
			],
			713: [
				.631,
				-.567,
				.5,
				{ ic: .065 }
			],
			714: [
				.694,
				-.527,
				.5,
				{ ic: .045 }
			],
			715: [
				.694,
				-.527,
				.5
			],
			728: [
				.7,
				-.522,
				.5,
				{ ic: .069 }
			],
			729: [
				.655,
				-.566,
				.278,
				{ ic: .045 }
			],
			730: [
				.685,
				-.517,
				.738
			],
			732: [
				.67,
				-.551,
				.5,
				{ ic: .06 }
			],
			768: [
				.694,
				-.527,
				0,
				{ dx: .145 }
			],
			769: [
				.694,
				-.527,
				0,
				{ dx: .074 }
			],
			770: [
				.697,
				-.525,
				0,
				{ dx: .129 }
			],
			771: [
				.67,
				-.551,
				0,
				{ dx: .11 }
			],
			772: [
				.643,
				-.579,
				0,
				{ dx: .11 }
			],
			773: [
				.682,
				-.642,
				.778,
				{ ic: .056 }
			],
			774: [
				.7,
				-.522,
				0,
				{ dx: .092 }
			],
			775: [
				.655,
				-.566,
				0,
				{ dx: .111 }
			],
			776: [
				.651,
				-.571,
				0,
				{ dx: .111 }
			],
			778: [
				.685,
				-.517,
				0,
				{ dx: .113 }
			],
			780: [
				.697,
				-.525,
				0,
				{ dx: .091 }
			],
			913: [
				.694,
				0,
				.667
			],
			914: [
				.694,
				0,
				.667,
				{ ic: .028 }
			],
			915: [
				.691,
				0,
				.542,
				{ ic: .105 }
			],
			916: [
				.694,
				0,
				.833
			],
			917: [
				.691,
				0,
				.597,
				{ ic: .092 }
			],
			918: [
				.694,
				0,
				.611,
				{ ic: .092 }
			],
			919: [
				.694,
				0,
				.708,
				{ ic: .054 }
			],
			920: [
				.716,
				.022,
				.778,
				{ ic: .026 }
			],
			921: [
				.694,
				0,
				.278,
				{ ic: .054 }
			],
			922: [
				.694,
				0,
				.694,
				{ ic: .098 }
			],
			923: [
				.694,
				0,
				.611
			],
			924: [
				.694,
				0,
				.875,
				{ ic: .048 }
			],
			925: [
				.694,
				0,
				.708,
				{ ic: .051 }
			],
			926: [
				.689,
				0,
				.667,
				{ ic: .098 }
			],
			927: [
				.716,
				.022,
				.736,
				{ ic: .027 }
			],
			928: [
				.691,
				0,
				.708,
				{ ic: .053 }
			],
			929: [
				.694,
				0,
				.639,
				{ ic: .052 }
			],
			931: [
				.694,
				0,
				.722,
				{ ic: .092 }
			],
			932: [
				.689,
				0,
				.68,
				{ ic: .111 }
			],
			933: [
				.716,
				0,
				.778,
				{ ic: .065 }
			],
			934: [
				.694,
				0,
				.722,
				{ ic: .022 }
			],
			935: [
				.694,
				0,
				.667,
				{ ic: .096 }
			],
			936: [
				.694,
				0,
				.778,
				{ ic: .075 }
			],
			937: [
				.716,
				0,
				.722,
				{ ic: .047 }
			],
			945: [
				.455,
				.011,
				.633
			],
			946: [
				.733,
				.139,
				.5,
				{ ic: .032 }
			],
			947: [
				.455,
				.171,
				.555,
				{ ic: .056 }
			],
			948: [
				.721,
				.011,
				.472,
				{ ic: .092 }
			],
			949: [
				.455,
				.011,
				.43,
				{ ic: .027 }
			],
			950: [
				.738,
				.153,
				.472,
				{ ic: .097 }
			],
			951: [
				.467,
				.195,
				.514,
				{ ic: .02 }
			],
			952: [
				.733,
				.011,
				.5,
				{ ic: .053 }
			],
			953: [
				.445,
				.011,
				.278
			],
			954: [
				.445,
				0,
				.483,
				{ ic: .034 }
			],
			955: [
				.722,
				0,
				.5
			],
			956: [
				.445,
				.195,
				.655
			],
			957: [
				.445,
				0,
				.472,
				{ ic: .053 }
			],
			958: [
				.744,
				.156,
				.472,
				{ ic: .056 }
			],
			959: [
				.455,
				.011,
				.472,
				{ ic: .011 }
			],
			960: [
				.445,
				.011,
				.583,
				{ ic: .053 }
			],
			961: [
				.455,
				.195,
				.472,
				{ ic: .011 }
			],
			962: [
				.445,
				.13,
				.444,
				{ ic: .054 }
			],
			963: [
				.445,
				.011,
				.569,
				{ ic: .066 }
			],
			964: [
				.445,
				.011,
				.458,
				{ ic: .053 }
			],
			965: [
				.445,
				.011,
				.5,
				{ ic: .016 }
			],
			966: [
				.456,
				.195,
				.583,
				{ ic: .015 }
			],
			967: [
				.458,
				.208,
				.555,
				{ ic: .06 }
			],
			968: [
				.722,
				.195,
				.583,
				{ ic: .027 }
			],
			969: [
				.445,
				.011,
				.667,
				{ ic: .009 }
			],
			977: [
				.733,
				.011,
				.5,
				{ ic: .057 }
			],
			978: [
				.716,
				0,
				.778,
				{ ic: .08 }
			],
			981: [
				.714,
				.195,
				.583,
				{ ic: .035 }
			],
			982: [
				.445,
				.011,
				.807,
				{ ic: .054 }
			],
			1008: [
				.458,
				.022,
				.555,
				{ ic: .059 }
			],
			1009: [
				.455,
				.249,
				.472,
				{ ic: .03 }
			],
			1012: [
				.716,
				.022,
				.778,
				{ ic: .061 }
			],
			1013: [
				.455,
				.011,
				.43,
				{ ic: .048 }
			],
			1014: [
				.455,
				.011,
				.43,
				{ ic: .029 }
			],
			8208: [
				.251,
				-.193,
				.333,
				{ ic: .02 }
			],
			8209: [
				.251,
				-.193,
				.333,
				{ ic: .02 }
			],
			8210: [
				.305,
				-.244,
				.5,
				{ ic: .065 }
			],
			8211: [
				.305,
				-.244,
				.5,
				{ ic: .065 }
			],
			8212: [
				.305,
				-.244,
				1,
				{ ic: .065 }
			],
			8214: [
				.75,
				.25,
				.398,
				{ ic: .038 }
			],
			8216: [
				.694,
				-.486,
				.278,
				{ ic: .052 }
			],
			8217: [
				.694,
				-.486,
				.278,
				{ ic: .051 }
			],
			8220: [
				.694,
				-.486,
				.472,
				{ ic: .052 }
			],
			8221: [
				.694,
				-.486,
				.472,
				{ ic: .052 }
			],
			8224: [
				.705,
				.216,
				.444,
				{ ic: .035 }
			],
			8225: [
				.705,
				.205,
				.444,
				{ ic: .045 }
			],
			8230: [
				.083,
				0,
				.626
			],
			8260: [
				.674,
				-.02,
				.558,
				{ ic: .091 }
			],
			8364: [
				.716,
				.022,
				.599,
				{ ic: .085 }
			],
			8486: [
				.716,
				0,
				.722,
				{ ic: .046 }
			],
			8487: [
				.694,
				.022,
				.722,
				{ ic: .105 }
			],
			8592: [
				.511,
				.009,
				1,
				{ ic: .001 }
			],
			8593: [
				.712,
				.195,
				.5,
				{ ic: .072 }
			],
			8594: [
				.511,
				.009,
				1
			],
			8595: [
				.695,
				.211,
				.5
			],
			8722: [
				.27,
				-.23,
				.778
			],
			8734: [
				.468,
				.024,
				1
			]
		}
	},
	SSBI: {
		normal: {
			120380: [
				.694,
				0,
				.733,
				{ sk: .144 }
			],
			120381: [
				.694,
				0,
				.733,
				{
					ic: .02,
					sk: .061
				}
			],
			120382: [
				.706,
				.011,
				.703,
				{
					ic: .073,
					sk: .174
				}
			],
			120383: [
				.694,
				0,
				.794,
				{
					ic: .023,
					sk: .033
				}
			],
			120384: [
				.692,
				0,
				.642,
				{
					ic: .084,
					sk: .097
				}
			],
			120385: [
				.692,
				0,
				.611,
				{
					ic: .099,
					sk: .093
				}
			],
			120386: [
				.706,
				.011,
				.733,
				{
					ic: .055,
					sk: .167
				}
			],
			120387: [
				.694,
				0,
				.794,
				{
					ic: .055,
					sk: .105
				}
			],
			120388: [
				.694,
				0,
				.331,
				{
					ic: .055,
					sk: .105
				}
			],
			120389: [
				.694,
				.022,
				.519,
				{
					ic: .055,
					sk: .2
				}
			],
			120390: [
				.694,
				0,
				.764,
				{
					ic: .085,
					sk: .097
				}
			],
			120391: [
				.694,
				0,
				.581,
				{ sk: .021 }
			],
			120392: [
				.694,
				0,
				.978,
				{
					ic: .054,
					sk: .105
				}
			],
			120393: [
				.694,
				0,
				.794,
				{
					ic: .055,
					sk: .105
				}
			],
			120394: [
				.717,
				.022,
				.794,
				{
					ic: .026,
					sk: .13
				}
			],
			120395: [
				.694,
				0,
				.703,
				{
					ic: .045,
					sk: .049
				}
			],
			120396: [
				.717,
				.111,
				.794,
				{
					ic: .025,
					sk: .13
				}
			],
			120397: [
				.694,
				0,
				.703,
				{
					ic: .047,
					sk: .054
				}
			],
			120398: [
				.717,
				.022,
				.611,
				{
					ic: .045,
					sk: .121
				}
			],
			120399: [
				.689,
				0,
				.733,
				{
					ic: .105,
					sk: .066
				}
			],
			120400: [
				.694,
				.022,
				.764,
				{
					ic: .055,
					sk: .105
				}
			],
			120401: [
				.694,
				0,
				.733,
				{
					ic: .131,
					sk: .046
				}
			],
			120402: [
				.694,
				0,
				1.039,
				{
					ic: .131,
					sk: .045
				}
			],
			120403: [
				.694,
				0,
				.733,
				{
					ic: .085,
					sk: .067
				}
			],
			120404: [
				.694,
				0,
				.733,
				{
					ic: .143,
					sk: .037
				}
			],
			120405: [
				.694,
				0,
				.672,
				{
					ic: .085,
					sk: .089
				}
			],
			120406: [
				.489,
				.011,
				.525,
				{
					ic: .013,
					sk: .091
				}
			],
			120407: [
				.694,
				.011,
				.561,
				{
					ic: .024,
					sk: -.025
				}
			],
			120408: [
				.489,
				.011,
				.489,
				{
					ic: .056,
					sk: .098
				}
			],
			120409: [
				.694,
				.011,
				.561,
				{
					ic: .086,
					sk: .233
				}
			],
			120410: [
				.489,
				.011,
				.511,
				{
					ic: .032,
					sk: .086
				}
			],
			120411: [
				.706,
				0,
				.336,
				{
					ic: .191,
					sk: .126
				}
			],
			120412: [
				.483,
				.191,
				.561,
				{
					ic: .041,
					sk: .126
				}
			],
			120413: [
				.694,
				0,
				.561,
				{
					ic: .016,
					sk: -.019
				}
			],
			120414: [
				.694,
				0,
				.256,
				{
					ic: .084,
					sk: .078
				}
			],
			120415: [
				.694,
				.178,
				.286,
				{
					ic: .086,
					sk: .085
				}
			],
			120416: [
				.694,
				0,
				.531,
				{
					ic: .055,
					sk: -.033
				}
			],
			120417: [
				.694,
				0,
				.256,
				{
					ic: .084,
					sk: .083
				}
			],
			120418: [
				.483,
				0,
				.867,
				{
					ic: .015,
					sk: .058
				}
			],
			120419: [
				.483,
				0,
				.561,
				{
					ic: .016,
					sk: .058
				}
			],
			120420: [
				.489,
				.011,
				.55,
				{
					ic: .027,
					sk: .078
				}
			],
			120421: [
				.483,
				.167,
				.561,
				{
					ic: .025,
					sk: .036
				}
			],
			120422: [
				.483,
				.167,
				.561,
				{
					ic: .041,
					sk: .129
				}
			],
			120423: [
				.483,
				0,
				.372,
				{
					ic: .086,
					sk: .063
				}
			],
			120424: [
				.489,
				.011,
				.422,
				{
					ic: .054,
					sk: .073
				}
			],
			120425: [
				.607,
				.011,
				.404,
				{
					ic: .05,
					sk: .038
				}
			],
			120426: [
				.472,
				.011,
				.561,
				{
					ic: .039,
					sk: .066
				}
			],
			120427: [
				.472,
				0,
				.5,
				{
					ic: .083,
					sk: .031
				}
			],
			120428: [
				.472,
				0,
				.744,
				{
					ic: .083,
					sk: .032
				}
			],
			120429: [
				.472,
				0,
				.5,
				{
					ic: .08,
					sk: .029
				}
			],
			120430: [
				.472,
				.178,
				.5,
				{
					ic: .083,
					sk: .033
				}
			],
			120431: [
				.472,
				0,
				.476,
				{
					ic: .062,
					sk: .051
				}
			],
			120720: [
				.694,
				0,
				.733,
				{ sk: .146 }
			],
			120721: [
				.694,
				0,
				.733,
				{
					ic: .048,
					sk: .063
				}
			],
			120722: [
				.694,
				0,
				.58,
				{
					ic: .101,
					sk: .085
				}
			],
			120723: [
				.694,
				0,
				.916,
				{ sk: .139 }
			],
			120724: [
				.692,
				0,
				.642,
				{
					ic: .084,
					sk: .09
				}
			],
			120725: [
				.694,
				0,
				.672,
				{
					ic: .085,
					sk: .082
				}
			],
			120726: [
				.694,
				0,
				.794,
				{
					ic: .055,
					sk: .097
				}
			],
			120727: [
				.716,
				.022,
				.855,
				{
					ic: .053,
					sk: .106
				}
			],
			120728: [
				.694,
				0,
				.331,
				{
					ic: .055,
					sk: .097
				}
			],
			120729: [
				.694,
				0,
				.764,
				{
					ic: .085,
					sk: .088
				}
			],
			120730: [
				.694,
				0,
				.672,
				{ sk: .138 }
			],
			120731: [
				.694,
				0,
				.978,
				{
					ic: .054,
					sk: .098
				}
			],
			120732: [
				.694,
				0,
				.794,
				{
					ic: .055,
					sk: .097
				}
			],
			120733: [
				.689,
				0,
				.733,
				{
					ic: .093,
					sk: .067
				}
			],
			120734: [
				.717,
				.022,
				.794,
				{
					ic: .037,
					sk: .111
				}
			],
			120735: [
				.691,
				0,
				.794,
				{
					ic: .054,
					sk: .098
				}
			],
			120736: [
				.694,
				0,
				.703,
				{
					ic: .052,
					sk: .067
				}
			],
			120737: [
				.716,
				.022,
				.856,
				{
					ic: .062,
					sk: .099
				}
			],
			120738: [
				.693,
				0,
				.794,
				{
					ic: .085,
					sk: .074
				}
			],
			120739: [
				.689,
				0,
				.733,
				{
					ic: .105,
					sk: .056
				}
			],
			120740: [
				.716,
				0,
				.855,
				{
					ic: .085,
					sk: .079
				}
			],
			120741: [
				.694,
				0,
				.794,
				{
					ic: .043,
					sk: .103
				}
			],
			120742: [
				.694,
				0,
				.733,
				{
					ic: .085,
					sk: .084
				}
			],
			120743: [
				.694,
				0,
				.855,
				{
					ic: .064,
					sk: .096
				}
			],
			120744: [
				.716,
				0,
				.794,
				{
					ic: .054,
					sk: .098
				}
			],
			120745: [
				.682,
				.012,
				.916,
				{
					ic: .027,
					sk: .051
				}
			],
			120746: [
				.455,
				.011,
				.633,
				{ ic: .013 }
			],
			120747: [
				.733,
				.139,
				.5,
				{
					ic: .058,
					sk: .088
				}
			],
			120748: [
				.455,
				.171,
				.555,
				{
					ic: .055,
					sk: .058
				}
			],
			120749: [
				.721,
				.011,
				.472,
				{
					ic: .097,
					sk: .044
				}
			],
			120750: [
				.455,
				.011,
				.43,
				{
					ic: .03,
					sk: .059
				}
			],
			120751: [
				.744,
				.153,
				.472,
				{
					ic: .1,
					sk: .088
				}
			],
			120752: [
				.467,
				.195,
				.514,
				{
					ic: .042,
					sk: .085
				}
			],
			120753: [
				.733,
				.011,
				.5,
				{
					ic: .078,
					sk: .115
				}
			],
			120754: [
				.445,
				.011,
				.278,
				{ sk: .059 }
			],
			120755: [
				.445,
				0,
				.483,
				{
					ic: .036,
					sk: .073
				}
			],
			120756: [
				.722,
				0,
				.5,
				{ sk: .057 }
			],
			120757: [
				.445,
				.195,
				.555,
				{
					ic: .011,
					sk: .062
				}
			],
			120758: [
				.445,
				0,
				.472,
				{
					ic: .052,
					sk: .067
				}
			],
			120759: [
				.747,
				.156,
				.472,
				{
					ic: .057,
					sk: .117
				}
			],
			120760: [
				.455,
				.011,
				.528,
				{
					ic: .032,
					sk: .079
				}
			],
			120761: [
				.445,
				.011,
				.583,
				{
					ic: .054,
					sk: .061
				}
			],
			120762: [
				.455,
				.195,
				.472,
				{
					ic: .028,
					sk: .086
				}
			],
			120763: [
				.445,
				.13,
				.444,
				{
					ic: .053,
					sk: .05
				}
			],
			120764: [
				.445,
				.011,
				.569,
				{
					ic: .066,
					sk: .042
				}
			],
			120765: [
				.445,
				.011,
				.458,
				{
					ic: .053,
					sk: .065
				}
			],
			120766: [
				.445,
				.011,
				.5,
				{
					ic: .022,
					sk: .075
				}
			],
			120767: [
				.455,
				.195,
				.583,
				{
					ic: .027,
					sk: .09
				}
			],
			120768: [
				.458,
				.208,
				.555,
				{
					ic: .068,
					sk: .036
				}
			],
			120769: [
				.722,
				.195,
				.583,
				{
					ic: .028,
					sk: .142
				}
			],
			120770: [
				.445,
				.011,
				.667,
				{
					ic: .025,
					sk: .087
				}
			],
			120771: [
				.716,
				.022,
				.569,
				{
					ic: .036,
					sk: .1
				}
			],
			120772: [
				.455,
				.011,
				.43,
				{
					ic: .048,
					sk: .072
				}
			],
			120773: [
				.705,
				.012,
				.811,
				{
					ic: .026,
					sk: .19
				}
			],
			120774: [
				.492,
				.033,
				.609,
				{ ic: .04 }
			],
			120775: [
				.695,
				.195,
				.611,
				{
					ic: .027,
					sk: .134
				}
			],
			120776: [
				.469,
				.245,
				.567,
				{
					ic: .008,
					sk: .084
				}
			],
			120777: [
				.458,
				.012,
				1.035,
				{
					ic: .061,
					sk: .109
				}
			]
		},
		"sans-serif-bold-italic": {
			305: [
				.458,
				0,
				.256,
				{
					ic: .027,
					sk: .313
				}
			],
			567: [
				.458,
				.205,
				.286,
				{
					ic: .028,
					sk: .195
				}
			],
			32: [
				0,
				0,
				.367
			],
			33: [
				.694,
				0,
				.367,
				{ ic: .029 }
			],
			35: [
				.694,
				.167,
				.917,
				{ ic: .023 }
			],
			36: [
				.75,
				.056,
				.55,
				{ ic: .057 }
			],
			37: [
				.773,
				.079,
				1.029
			],
			38: [
				.717,
				.022,
				.831
			],
			39: [
				.695,
				-.453,
				.306,
				{ ic: .059 }
			],
			40: [
				.75,
				.222,
				.428,
				{ ic: .096 }
			],
			41: [
				.75,
				.222,
				.428,
				{ ic: .01 }
			],
			42: [
				.75,
				-.278,
				.55,
				{ ic: .065 }
			],
			43: [
				.626,
				.098,
				.856
			],
			44: [
				.131,
				.111,
				.306
			],
			45: [
				.272,
				-.2,
				.367
			],
			46: [
				.131,
				0,
				.306
			],
			47: [
				.775,
				.195,
				.55,
				{ ic: .113 }
			],
			48: [
				.717,
				.022,
				.55,
				{ ic: .071 }
			],
			49: [
				.717,
				0,
				.55
			],
			50: [
				.717,
				0,
				.55,
				{ ic: .074 }
			],
			51: [
				.717,
				.022,
				.55,
				{ ic: .063 }
			],
			52: [
				.694,
				0,
				.55,
				{ ic: .025 }
			],
			53: [
				.694,
				.022,
				.55,
				{ ic: .055 }
			],
			54: [
				.717,
				.022,
				.55,
				{ ic: .035 }
			],
			55: [
				.694,
				.011,
				.55,
				{ ic: .1 }
			],
			56: [
				.717,
				.022,
				.55,
				{ ic: .059 }
			],
			57: [
				.717,
				.022,
				.55,
				{ ic: .071 }
			],
			58: [
				.471,
				0,
				.306,
				{ ic: .011 }
			],
			59: [
				.471,
				.111,
				.306,
				{ ic: .011 }
			],
			61: [
				.425,
				-.103,
				.856,
				{ ic: .024 }
			],
			63: [
				.706,
				0,
				.519,
				{ ic: .08 }
			],
			64: [
				.706,
				.011,
				.733,
				{ ic: .061 }
			],
			91: [
				.75,
				.222,
				.343,
				{ ic: .133 }
			],
			92: [
				.775,
				.262,
				.575
			],
			93: [
				.75,
				.222,
				.343,
				{ ic: .072 }
			],
			94: [
				.744,
				-.562,
				.556,
				{ ic: .129 }
			],
			95: [
				-.057,
				.193,
				.733
			],
			96: [
				.694,
				-.537,
				.55
			],
			123: [
				.75,
				.25,
				.575,
				{ ic: .081 }
			],
			124: [
				.796,
				.282,
				.338,
				{ ic: .045 }
			],
			125: [
				.75,
				.25,
				.575
			],
			126: [
				.327,
				-.173,
				.556,
				{ ic: .056 }
			],
			160: [
				0,
				0,
				.367
			],
			163: [
				.694,
				.047,
				.733
			],
			165: [
				.694,
				0,
				.733,
				{ ic: .143 }
			],
			167: [
				.709,
				.209,
				.566,
				{ ic: .085 }
			],
			168: [
				.62,
				-.515,
				.527,
				{ ic: .044 }
			],
			172: [
				.408,
				-.098,
				.856,
				{ ic: .025 }
			],
			175: [
				.658,
				-.573,
				.55,
				{ ic: .064 }
			],
			176: [
				.694,
				-.389,
				.413,
				{ ic: .079 }
			],
			177: [
				.691,
				0,
				.856,
				{ ic: .018 }
			],
			180: [
				.694,
				-.537,
				.55,
				{ ic: .029 }
			],
			181: [
				.445,
				.195,
				.555,
				{ ic: .012 }
			],
			182: [
				.694,
				.194,
				.703,
				{ ic: .115 }
			],
			183: [
				.413,
				-.282,
				.856
			],
			215: [
				.54,
				.039,
				.856
			],
			240: [
				.69,
				.01,
				.55,
				{ ic: .018 }
			],
			247: [
				.507,
				.039,
				.856
			],
			710: [
				.694,
				-.546,
				.55,
				{ ic: .006 }
			],
			711: [
				.661,
				-.513,
				.55,
				{ ic: .03 }
			],
			713: [
				.658,
				-.573,
				.55,
				{ ic: .064 }
			],
			714: [
				.694,
				-.537,
				.55,
				{ ic: .029 }
			],
			715: [
				.694,
				-.537,
				.55
			],
			728: [
				.694,
				-.522,
				.55,
				{ ic: .06 }
			],
			729: [
				.699,
				-.594,
				.306,
				{ ic: .047 }
			],
			730: [
				.729,
				-.546,
				.223,
				{ ic: .128 }
			],
			732: [
				.694,
				-.567,
				.55,
				{ ic: .055 }
			],
			768: [
				.684,
				-.537,
				0,
				{ dx: .073 }
			],
			769: [
				.685,
				-.537,
				0,
				{ dx: .069 }
			],
			770: [
				.698,
				-.549,
				0,
				{ dx: .144 }
			],
			771: [
				.668,
				-.553,
				.733
			],
			772: [
				.658,
				-.573,
				0,
				{ dx: .131 }
			],
			773: [
				.717,
				-.632,
				.855,
				{ ic: .059 }
			],
			774: [
				.708,
				-.536,
				.256
			],
			775: [
				.672,
				-.567,
				0,
				{ dx: .12 }
			],
			776: [
				.672,
				-.567,
				.733
			],
			778: [
				.705,
				-.522,
				.733
			],
			780: [
				.698,
				-.549,
				0,
				{ dx: .103 }
			],
			978: [
				.716,
				0,
				.778,
				{ ic: .079 }
			],
			1014: [
				.455,
				.011,
				.43,
				{ ic: .03 }
			],
			8208: [
				.265,
				-.193,
				.367,
				{ ic: .02 }
			],
			8209: [
				.265,
				-.193,
				.367,
				{ ic: .02 }
			],
			8210: [
				.32,
				-.247,
				.55,
				{ ic: .062 }
			],
			8211: [
				.328,
				-.256,
				.55,
				{ ic: .068 }
			],
			8212: [
				.328,
				-.256,
				1.1,
				{ ic: .068 }
			],
			8214: [
				.75,
				.25,
				.571,
				{ ic: .03 }
			],
			8216: [
				.722,
				-.48,
				.306,
				{ ic: .056 }
			],
			8217: [
				.722,
				-.48,
				.305,
				{ ic: .059 }
			],
			8220: [
				.722,
				-.48,
				.61,
				{ ic: .066 }
			],
			8221: [
				.722,
				-.48,
				.61
			],
			8224: [
				.702,
				.211,
				.511,
				{ ic: .036 }
			],
			8225: [
				.702,
				.202,
				.511,
				{ ic: .043 }
			],
			8230: [
				.131,
				0,
				.768
			],
			8260: [
				.735,
				.039,
				.55,
				{ ic: .201 }
			],
			8364: [
				.716,
				.022,
				.658,
				{ ic: .075 }
			],
			8486: [
				.716,
				0,
				.794,
				{ ic: .054 }
			],
			8487: [
				.716,
				0,
				.794,
				{ ic: .102 }
			],
			8592: [
				.548,
				.046,
				1.1
			],
			8593: [
				.668,
				.194,
				.622,
				{ ic: .079 }
			],
			8594: [
				.548,
				.046,
				1.1
			],
			8595: [
				.668,
				.194,
				.622,
				{ ic: .012 }
			],
			8722: [
				.293,
				-.208,
				.856
			],
			8734: [
				.492,
				.034,
				1.1,
				{ ic: .031 }
			]
		}
	}
}, "NCM"));
//#endregion
